module.exports = __webpack_public_path__ + "static/02-track-82dae618b2c29112ddb8eed031c32a8b.jpg";